export const MAINTENANCE_BYPASS_QUERY_PARAM = "maintenanceBypass";
export const MAINTENANCE_BYPASS_CLEAR_VALUE = "clear";
export const MAINTENANCE_BYPASS_STORAGE_KEY = "maintenanceBypassActive";

export function getMaintenanceBypassKey(): string {
  return globalThis.env?.MAINTENANCE_BYPASS_KEY?.trim() ?? "";
}

export function isMaintenanceBypassConfigured(): boolean {
  return getMaintenanceBypassKey().length > 0;
}

export function isMaintenanceBypassActive(): boolean {
  if (!isMaintenanceBypassConfigured()) {
    return false;
  }

  try {
    return sessionStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function setMaintenanceBypassActive(): void {
  sessionStorage.setItem(MAINTENANCE_BYPASS_STORAGE_KEY, "true");
}

export function clearMaintenanceBypass(): void {
  try {
    sessionStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export function syncMaintenanceBypassWithConfig(maintenanceEnabled: boolean): void {
  if (!maintenanceEnabled) {
    clearMaintenanceBypass();
  }
}

function removeBypassQueryParamFromUrl(params: URLSearchParams): void {
  params.delete(MAINTENANCE_BYPASS_QUERY_PARAM);
  const newSearch = params.toString();
  const searchSuffix = newSearch ? `?${newSearch}` : "";
  const newUrl = `${globalThis.location.pathname}${searchSuffix}${globalThis.location.hash}`;
  globalThis.history.replaceState(null, "", newUrl);
}

export function isValidMaintenanceBypassKey(providedKey: string): boolean {
  const configuredKey = getMaintenanceBypassKey();
  return configuredKey.length > 0 && providedKey === configuredKey;
}

export function activateMaintenanceBypassFromUrl(search?: string): boolean {
  if (!isMaintenanceBypassConfigured()) {
    return isMaintenanceBypassActive();
  }

  const params = new URLSearchParams(search ?? globalThis.location.search);
  const providedKey = params.get(MAINTENANCE_BYPASS_QUERY_PARAM);

  if (providedKey === MAINTENANCE_BYPASS_CLEAR_VALUE) {
    clearMaintenanceBypass();
    removeBypassQueryParamFromUrl(params);
    return false;
  }

  if (providedKey && isValidMaintenanceBypassKey(providedKey)) {
    try {
      setMaintenanceBypassActive();
    } catch {
      return false;
    }

    removeBypassQueryParamFromUrl(params);
    return true;
  }

  return isMaintenanceBypassActive();
}

export function shouldShowMaintenancePage(maintenanceEnabled: boolean): boolean {
  return maintenanceEnabled && !isMaintenanceBypassActive();
}
